import { isDate } from "./isDate";

export const isValidDate = (value: unknown): value is Date => isDate(value) && !Number.isNaN(value.getTime());
